import "../../styles.css";

const TermsOfUse = () => {
  return (
    <div className="terms-of-use-container">
      <header className="terms-of-use-header">
        <h1>Terms of Use</h1>
        <h2>Gig Genie</h2>
      </header>

      <section className="terms-of-use-section">
        <h3>Acceptance of Terms</h3>
        <p>
          By accessing or using Gig Genie (the “app”), you agree to be bound by these Terms of Use. If you do not agree to these terms, do not use the app.
        </p>
      </section>

      <section className="terms-of-use-section">
        <h3>Use of the App</h3>
        <p>
          The app is provided for personal use to help you track income, bills, and gig-related finances. You may use the app only for lawful purposes and in accordance with these terms.
        </p>
      </section>

      <section className="terms-of-use-section">
        <h3>User Responsibilities</h3>
        <p>
          You are responsible for the accuracy of any information you enter into the app. You must not use the app to violate any law, infringe on others’ rights, or transmit harmful or offensive content. You are responsible for keeping your device and account access secure.
        </p>
      </section>

      <section className="terms-of-use-section">
        <h3>Limitation of Liability</h3>
        <p>
          The app is provided “as is.” We do not guarantee that it will be error-free or uninterrupted. To the fullest extent permitted by law, we are not liable for any indirect, incidental, special, or consequential damages arising from your use of the app, including any reliance on the app for financial or tax decisions. You use the app at your own risk.
        </p>
      </section>

      <section className="terms-of-use-section">
        <h3>Intellectual Property</h3>
        <p>
          All content, features, and functionality of the app (including but not limited to text, graphics, logos, and software) are owned by us or our licensors and are protected by copyright and other intellectual property laws. You may not copy, modify, distribute, or create derivative works without our permission.
        </p>
      </section>

      <section className="terms-of-use-section">
        <h3>Subscription and Payment</h3>
        <p>
          Some features may require a paid subscription. Subscription terms, pricing, and payment methods are shown in the app or at the point of purchase. Payments may be processed by third-party providers. Refund and cancellation policies are governed by the platform through which you subscribed (e.g., App Store or Google Play).
        </p>
      </section>

      <section className="terms-of-use-section">
        <h3>Contact</h3>
        <p>
          For questions about these Terms of Use, contact us at{" "}
          <a href="mailto:mygiggenie@gmail.com">mygiggenie@gmail.com</a>.
        </p>
      </section>
    </div>
  );
};

export default TermsOfUse;
